module.exports = "<div>\n    <p>{{'Number of inputs' | translate}}: {{$ctrl.totalCount}}</p>\n    <cms-grid grid-options=\"$ctrl.options\"\n              datasource=\"$ctrl.datasource\"\n              initial-sort-model=\"$ctrl.initialSortModel\"\n              initial-filter-model=\"$ctrl.initialFilterModel\"\n              on-page-change=\"$ctrl._onPageChange($page)\"></cms-grid>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/PagesModules/PageFormDataGrid/page-form-data-grid.html
// module id = 1016
// module chunks = 0